module["exports"] = [
  "ახალი",
  "ძველი",
  "ზემო",
  "ქვემო"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ge/address/city_prefix.js
// module id = 1709
// module chunks = 0